import PropTypes from 'prop-types';
import './AddressPreviewCard.scss';

const InfoField = ({ value }) => value ? (
  <div className="sp-info-field">
    <span className="sp-info-value">{value}</span>
  </div>
) : null;

InfoField.propTypes = {
  value: PropTypes.string
};

const AddressPreviewCard = ({ address, villageName, talukaName, districtName, stateName, pincode,
  nationality, className, isBackGroundStyle
}) => {
  return (
    <div className={`address-preview-card ${className || ""} ${isBackGroundStyle && "background-style"}`}>
      <InfoField value={address} />
      <InfoField value={[villageName, talukaName, districtName].filter(Boolean).join(", ")} />
      <InfoField value={[stateName, pincode].filter(Boolean).join(" - ")} />
      <InfoField value={nationality} />
    </div>
  );
};

AddressPreviewCard.propTypes = {
  address: PropTypes.string,
  villageName: PropTypes.string,
  talukaName: PropTypes.string,
  districtName: PropTypes.string,
  stateName: PropTypes.string,
  pincode: PropTypes.string,
  nationality: PropTypes.string,
  className: PropTypes.string,
  isBackGroundStyle: PropTypes.bool
};

export default AddressPreviewCard;
